/**
 * One card in the printed report. Border-left + reason styling pull
 * directly from the `--rt-*` CSS tokens.
 */

import type { Card } from '@eloquor/api-contract';

export function ReportCard({ card }: { card: Card }) {
  return (
    <article
      className="report-card"
      style={{
        borderLeft: `3px solid var(--rt-${card.verdict})`,
      }}
    >
      <header className="report-card-head">
        <span>
          #{String(card.ord).padStart(3, '0')}
          {card.red && ' · ⚑'}
          {card.missingCite && ' · no cite'}
        </span>
        <span
          style={{
            color: `var(--rt-${card.verdict}-ink)`,
            background: `var(--rt-${card.verdict}-soft)`,
            border: `1px ${card.verdict === 'unchecked' ? 'dashed' : 'solid'} var(--rt-${card.verdict})`,
            padding: '1px 6px',
            borderRadius: 2,
            fontFamily: 'JetBrains Mono, monospace',
            fontSize: 10,
            letterSpacing: '0.02em',
          }}
        >
          {card.verdict}
        </span>
      </header>
      <div className="report-card-tag">{card.tag}</div>
      <div className="report-card-cite">{card.cite}</div>
      <div className="report-card-body">
        {card.segments.map((s, i) => (
          <span key={i} className={s.highlighted ? 'hl' : undefined}>
            {s.text}
          </span>
        ))}
      </div>
      {card.reason && (
        <div
          className="report-card-reason"
          style={{ color: `var(--rt-${card.verdict}-ink)` }}
        >
          {card.reason}
        </div>
      )}
    </article>
  );
}
